/*============ Legacy eligibility controller
 ================================*/
angular
.module('vppApp')
.controller('legacyController', legacyController);

legacyController.$inject = ['$scope', '$rootScope', '$state', 'apiFactory', 'dobFilter', 'ScrollToService', 'DTMTrackerService'];

function legacyController($scope, $rootScope, $state, apiFactory, dobFilter, ScrollToService, DTMTrackerService) {
  $scope.responsePending = false;
  $scope.legacySuccess = false;
  $scope.serverError = '';
  $scope.flpReferenceNumber = '';

  $scope.formData = {
    firstName: '',
    lastName: '',
    email: '',
    addressLine1: '',
    city: '',
    state: '',
    zip: '',
    dob: '',
    phoneNumber: '',
    retireeFirstName: '',
    retireeLastName: '',
    retireeMiddleInitial: '',
    retireeDob: '',
    retireeDod: '',
    spouseFirstName: '',
    spouseLastName: '',
    spouseMiddleInitial: '',
    spouseDob: '',
    spouseDod: ''
  };

  DTMTrackerService.updatePageLoadData('pageType', 'eligibility form');

  $scope.submit = function (formData) {
    // disable submit button
    $scope.responsePending = true;

    // date formatting
    $scope.formData.dob = dobFilter($scope.formData.dob);
    $scope.formData.retireeDob = dobFilter($scope.formData.retireeDob);
    $scope.formData.retireeDod = dobFilter($scope.formData.retireeDod);
    $scope.formData.spouseDob = dobFilter($scope.formData.spouseDob);
    $scope.formData.spouseDod = dobFilter($scope.formData.spouseDod);

    // submit form
    apiFactory.legacyEligibility(formData)
    .then(function successEligibility(response) {
      // set reference number
      $scope.flpReferenceNumber = response.data.flpReferenceNumber;

      // hide form, show success content
      $scope.legacySuccess = true;

      DTMTrackerService.updatePageLoadData('pageType', 'eligibility form-thanks');
      DTMTrackerService.directCall('form-success');

      // scroll to top of page
      window.localStorage.removeItem("idOrName_");
      window.localStorage['idOrName_'] = 'ng-app';
      ScrollToService.idOrName(undefined);

    }, function errorCallback(response) {
      // re-enable submit button
      $scope.responsePending = false;

      // set var to display errors
      $scope.serverError = response.data.errors;
    });
  };
};
